import TripDetails from './TripDetails.jsx';
import './TripDetails.css';

export default TripDetails;
